import Vue from 'vue'
import App from './App.vue'

import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import axios from 'axios' 
import Api from "./libs/api";
axios.defaults.baseURL ="/api";
import { alert } from 'element-ui';
window.eventBus = new Vue();
// console.log(eventBus)
// import Watermark from './libs/watermark';
Vue.prototype.$alert=alert
// Vue.prototype.Watermark=Watermark
import Print from 'vue-print-nb'
Vue.use(Print);  
axios.interceptors.response.use(function (response) {
  if(response.data.code==405){
      // message.error('身份验证失败,请重新登陆!');
      router.replace('/');
      return;
  }
  if(response.data.code==621){
  //  this.$alert("权限不足")
   console.log(1111)
    return
  }
  return response;
}, function (error) {
  // message.error('网络请求错误!');
  return;
  //return Promise.reject(error);
});





Vue.prototype.Api = Api;

Vue.prototype.$ajax = axios
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
